import { AppLanguages, TranslationsResponse } from '@interfaces'
import { api } from '@utils/api/api'

export const getTranslations = (
  language: AppLanguages,
): Promise<TranslationsResponse> => {
  return api.get(`/api/v1/translation/${language as string}`, true)
}
